import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { rowsPrepare } from '@helpers/datatables';
import { Page } from '@models/datatables';
import { Permisos } from '@app/models/account';

import { AccountService } from '@services/account.service';

import { Perfil, Usuario } from './usuarios';

const baseUrl = `${environment.apiUrl }`;

@Injectable({
    providedIn: 'root'
})
export class UsuariosService {
    usuarioId: number;
    seccionId: number;

    public get permisos(): Permisos {
        return this.obtenerPermisos();
    }

    constructor(
        private http: HttpClient,
        private accountService: AccountService
    ) {
        this.usuarioId = this.accountService.accountValue.id;
        this.seccionId = 7;
    }

    public listar() {
        return this.http.get<any>(
            `${baseUrl}/usuarios`
        );
    }

    public listarDT(page: Page, parametros) {
        return this.http.post<any>(
            `${baseUrl}/usuarios/listar-dt`,
            {
                parametros,
                pageSize: page.limit,
                pageNumber: page.offset,
                orderColumn: page.orderBy,
                orderDir: page.orderDir,
                start: page.offset*page.limit
            }
        ).pipe(map((resp:any) => {
            return {
                data: rowsPrepare(resp.data.data), 
                total: resp.data.total
            };
        }));
    }

    public cargar(id: number) {
        return this.http.get<any>(
            `${baseUrl}/usuarios/${id}`
        );
    }

    public guardar(id: number, datos: Usuario) {
        if (!id) {
            return this.http.post(
                `${baseUrl}/usuarios`,
                datos);
        } else {
            return this.http.put(
                `${baseUrl}/usuarios/${id}`,
                datos);
        }
    }

    public eliminar(id: number) {
        return this.http.delete(
            `${baseUrl}/usuarios/${id}`
        );
    }

    public cambiarTipo(id: number, tipo: number) {
        return this.http.put(
            `${baseUrl}/usuarios/cambiar-tipo/${id}/${tipo}`,
            {}
        );
    }

    public activar(id: number, activo: boolean) {
        return this.http.put(
            `${baseUrl}/usuarios/activar/${id}/${(activo ? 1 : 0)}`,
            {}
        );
    }

    public cambiarPassword(id: number, datos: Perfil) {
        return this.http.put(
            `${baseUrl}/usuarios/${id}/cambiar-password`,
            datos
        );
    }

    public cargarDatos() {
        return this.http.get(
            `${baseUrl}/usuarios/cargar-datos`
        );
    }

    // permisos
    public permisoListar(usuarioId: number) {
        return this.http.get<any>(
            `${baseUrl}/usuarios/permisos/listar/${usuarioId}`
        );
    }

    public moduloActivar(usuarioId: number, moduloId: number, activo: boolean) {
        return this.http.put(
            `${baseUrl}/usuarios/modulos/activar/${usuarioId}/${moduloId}/${(activo ? 1 : 0)}`,
            {}
        );
    }

    public seccionActivar(usuarioId: number, seccionId: number, activo: boolean) {
        return this.http.put(
            `${baseUrl}/usuarios/secciones/activar/${usuarioId}/${seccionId}/${(activo ? 1 : 0)}`,
            {}
        );
    }

    public permisoActivar(usuarioId: number, seccionId: number, permisoId: number, activo: boolean) {
        return this.http.put(
            `${baseUrl}/usuarios/permisos/activar/${usuarioId}/${seccionId}/${permisoId}/${(activo ? 1 : 0)}`,
            {}
        );
    }

    private obtenerPermisos() {
        let datos: any = [];

        let permisos = this.accountService.permisosSecciones(this.seccionId);
        let administrador = this.accountService.esAdministrador();

        permisos.forEach( (item, indice) => {
            if (item.id == 1) datos.listar = (administrador) ? true : item.checked;
            if (item.id == 2) datos.crear = (administrador) ? true : item.checked;
            if (item.id == 3) datos.editar = (administrador) ? true : item.checked;
            if (item.id == 4) datos.eliminar = (administrador) ? true : item.checked;
            if (item.id == 5) datos.activar = (administrador) ? true : item.checked;
            if (item.id == 11) datos.permisos = (administrador) ? true : item.checked;
        });

        return datos;
    }
}
